import React, { Component } from 'react';
import {
    List,
    Datagrid,
    TextField,
    NumberField,
    Pagination,
    Filter,
    TextInput,
    SelectInput,
    withDataProvider,
    FunctionField,
    Button,
} from 'react-admin';
import { Clear } from '@material-ui/icons';
import CustomActiveField from "../common/CustomActiveField"
import ActiveFieldWithToggle from "./ActiveFieldWithToggle"
import { COUNTRY_LIST } from '../constants/countries';
import { ACCOUNT_APPROVED_STATUS } from '../constants/account';
import { QuestionAndOptions } from '../constants/business';

const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100,200,500]} {...props} />
class AccountListFilter extends Component {
    state = {
        promoterChoices: []
    };

    componentDidMount() {
        const { dataProvider } = this.props;
        let permissions = localStorage.getItem("BITFA:DASHBOARD:AUTH:USERTYPE");
        // 只有特定权限才获取promoter数据
        if (permissions == "system_admin" || permissions == "operator" || permissions == "support" || permissions == "promoter") {
            // 获取账户列表数据来提取promoter选项
            dataProvider('GET_LIST', 'promoters', {
                pagination: { page: 1, perPage: 1000 }, // 获取足够多的数据
                sort: { field: 'id', order: 'ASC' },
                filter: {}
            })
            .then(({ data }) => {
                // 提取唯一的promoter值
                const promoters = [...new Set(data
                    .map(promoters => promoters)
                    .filter(promoter => promoter.name && promoter.name.trim() !== '')
                )];
                
                // 转换为SelectInput需要的格式
                const promoterChoices = promoters.map(promoter => ({
                    id: promoter.id,
                    name: promoter.name
                }));
                
                this.setState({ promoterChoices });
            })
            .catch(error => {
                console.error('Error fetching promoter options:', error);
            });
        }
    }

    render() {
        const { permissions, ...props } = this.props;
        const { promoterChoices } = this.state;
        
        return (
            <Filter {...props}>
                <TextInput label="Company Name" source="companyName" alwaysOn />
                <TextInput label="Account Number" source="account_number" alwaysOn />
                <SelectInput
                    source="countrySymbol"
                    label="Country"
                    choices={COUNTRY_LIST}
                    alwaysOn
                />
                <SelectInput
                    source="active"
                    label="Active"
                    choices={[
                        { id: "Active", name: 'Active' },
                        { id: "Inactive", name: 'Inactive' },
                        { id: "All", name: 'All' }
                    ]}
                    alwaysOn
                />
                {permissions == "system_admin" || permissions == "operator" || permissions == "support" || permissions == "promoter" ?
                    <TextInput label="Phone Number" source="phone_number" alwaysOn />: null
                }
                {permissions == "system_admin" || permissions == "operator" || permissions == "support" || permissions == "promoter" ?
                    <SelectInput
                        label="Promoter"
                        source="promoter"
                        choices={promoterChoices}
                        alwaysOn
                        allowEmpty
                    />: null
                }
                {permissions == "system_admin" || permissions == "operator" || permissions == "support" || permissions == "promoter" ?
                    <SelectInput
                        source="approvedStatus"
                        label="Approved Status"
                        choices={Object.keys(ACCOUNT_APPROVED_STATUS).map(key => ({
                            id: key,
                            name: ACCOUNT_APPROVED_STATUS[key]
                        }))}
                        alwaysOn
                    />
                    : null}
                {permissions == "system_admin" || permissions == "operator" || permissions == "support" || permissions == "promoter"  ?
                    <SelectInput
                        source="needSettlement"
                        label="Need Settlement"
                        choices={[
                            { id: "Yes", name: 'Yes' },
                            { id: "No", name: 'No' },
                            { id: "All", name: 'All' }
                        ]}
                        alwaysOn
                    />
                    : null}    
                <Button
                    label="Clear Filters"
                    onClick={() => {
                        // 清除所有过滤器
                        this.props.setFilters({}, []);
                    }}
                    alwaysOn
                >
                    <Clear />
                </Button>
            </Filter>
        )
    }
}

// 使用withDataProvider包装AccountListFilter
const EnhancedAccountListFilter = withDataProvider(AccountListFilter);

const AccountList = ({ permissions, ...props }) => {


    return (
        <List {...props} filters={<EnhancedAccountListFilter permissions={permissions} />} pagination={<PostPagination />} bulkActionButtons={false} exporter={false} hasCreate={false} /*hasCreate={permissions == 'store_owner'}*/>
            <Datagrid 
                rowClick={permissions != "promoter" ? "show" : false}
                rowStyle={(record) => ({
                    backgroundColor: record.approvedStatus === 'Pending Clarification' ? '#ffebee' : 'inherit'
                })}
            >
                <TextField source="accountNumber" label="Account Number" />
                <TextField source="companyName" label="Company Name" />
                <FunctionField 
                    label="Business Type" 
                    render={record => {
                        if (record.businessType) {
                            const businessType = QuestionAndOptions.business_type.options.find(
                                option => option.id === record.businessType
                            );
                            return businessType ? businessType.name : '-';
                        }
                        return '-';
                    }}
                />
                {permissions != "promoter" ?[
                <TextField source="phoneNumber" label="Phone Number" />,
                <TextField source="registrationNumber" label="Registration Number" />,
                <TextField source="formationDate" label="Date of Formation" />
                ]:null}
                <TextField source="countrySymbol" label="Country" />
                {permissions != "promoter" ?[
                <TextField source="currencySymbol" label="Currency" />,
                <TextField source="email" label="Email" />
                ]:null}
                <TextField source="countrySymbol" label="Country" />
                {permissions == "system_admin" || permissions == "operator"  || permissions == "support" || permissions == "promoter" ? [
                  <TextField source="promoter" label="Promoter" />
                ]:null}
                <FunctionField 
                    label="User Name" 
                    render={record => {
                        if (record.user_name) {
                            return (
                                <a 
                                    style={{ textDecoration: 'none', color: '#1976d2' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        window.location.hash = `#/users?filter={"name":"${record.user_name}"}`;
                                    }}
                                >
                                    {record.user_name}
                                </a>
                            );
                        }
                        return '-';
                    }}
                />
                {permissions == "system_admin" || permissions == "operator" ? (
                    <FunctionField
                        label="Active"
                        render={record => <ActiveFieldWithToggle record={record} />}
                    />
                ) : (
                    <CustomActiveField source="active" />
                )}
                <TextField source="activeDate" label="Active Date" />
                {permissions == "system_admin" || permissions == "operator" || permissions == "support" || permissions == "promoter" ? [
                    <TextField source="availableLimit" label="Available Credit" />,
                    <NumberField source="creditLimit" label="Credit Limit" />, 
                ] : null}
                {permissions == "system_admin" || permissions == "operator" || permissions == "support" ? [
                    <NumberField source="notifyUpperLimit" label="Sell Notify Upper Limit" />,               
                ] : null}
                <TextField source="approvedStatus" label="Approved Status" />
                <TextField source="approvedDate" label="Approved Date" />
                <TextField source="payoutDate" label="Payout Date" />
                <TextField source="createdAt" label="Create Date" />
                <TextField source="lastTransactionDate" label="Last Transaction Date" />
            </Datagrid>
        </List>
    )
};

export default AccountList;
